import React, { Component } from 'react';
import { connect } from 'react-redux';
import Banner from '../../components/Common/Banner/Banner';
import BelowBanner from './parts/BelowBanner/BelowBanner';
import OurProcess from './parts/OurProcess/OurProcess';
import WeHaveWorkedWith from '../../components/Common/WeHaveWorkedWith/WeHaveWrokedWith';
import GetStarted from '../../components/Common/GetStarted/GetStarted';

class HomePage extends Component {
  render() {
    return (
      <div>
        <Banner />
        <BelowBanner />
        <OurProcess />
        <WeHaveWorkedWith />
        <GetStarted />
      </div>
    )
  }
}

export default connect()(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js